export const debugEnabled = (flag: string): boolean =>
	(process.env.JFE_DEBUG || '').split(',').includes(flag);
